import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FieldError, UseFormMethods } from "react-hook-form";
import { alphaNumericWithoutSpaceRegex } from "@utils/regex";

interface IParams {
    register: UseFormMethods["register"];
    error: FieldError | undefined;
}

export const AccountNumber = (props: IParams) => {
    const { error, register } = props;
    const { t } = useTranslation(["portin", "validation"]);

    return (
        <TextField
            className="xtest_current_account_number_input"
            error={Boolean(error)}
            helperText={error?.message}
            id="current-account-number"
            inputRef={register({
                required: t("validation:required"),
                maxLength: { value: 24, message: t("validation:tooManyCharacters", { count: 24 }) },
                pattern: { value: alphaNumericWithoutSpaceRegex, message: t("validation:onlyLettersNumbers") },
            })}
            label={`${t("portin:accountNumber")} *`}
            margin="dense"
            name="accountNumber"
            style={{ width: "90%" }}
            type="text"
        />
    );
};
